/**
 * @generated SignedSource<<32694d28d2252a41c0fef138bec7f544>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutCreditCards_buyer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutCreditCardForm_buyer" | "CheckoutCreditCardListWrapper_buyer" | "checkoutPayment_buyer">;
  readonly " $fragmentType": "CheckoutCreditCards_buyer";
};
export type CheckoutCreditCards_buyer$key = {
  readonly " $data"?: CheckoutCreditCards_buyer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutCreditCards_buyer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutCreditCards_buyer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutCreditCardListWrapper_buyer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutCreditCardForm_buyer"
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "checkoutPayment_buyer",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Wallet",
          "kind": "LinkedField",
          "name": "wallet",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasCreditCards",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasBankAccounts",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": []
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "8a832e8499c2de20abf55f1feb64e01b";

export default node;
